import { render, staticRenderFns } from "./SearchContentComponent.vue?vue&type=template&id=2e2063e2&scoped=true&"
import script from "./SearchContentComponent.vue?vue&type=script&lang=js&"
export * from "./SearchContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./SearchContentComponent.vue?vue&type=style&index=0&id=2e2063e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2063e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
